import { render } from "./App.vue?vue&type=template&id=503bc300"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=503bc300&lang=css"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__